/**
 * Monogram for a campaign tile. Visual color comes from LLui's default theme;
 * campaign ids no longer mint an app-specific palette.
 */
export function monogram(name: string): string {
  const trimmed = name.trim();
  if (trimmed.length === 0) return '·';
  // Use the first code point so multi-byte scripts render a whole glyph.
  return Array.from(trimmed)[0]?.toUpperCase() ?? '·';
}
